import styles from "./ResponsivePage.module.css"
import { LeftOutlined } from "@ant-design/icons"
import { useNavigate } from "react-router-dom"
import PropTypes from "prop-types"

export const ResponsivePage = ({ children, pageTitle }) => {
  const navigate = useNavigate()
  const onBackClick = () => {
    navigate(-1)
  }
  return (
    <>
      <h4 className={`${styles.pageHeading} fw-700 flex gap-m pb-l`}>
        <LeftOutlined width={5} className={styles.backIcon} onClick={onBackClick} /> {pageTitle}
      </h4>
      {children}
    </>
  )
}

ResponsivePage.propTypes = {
  children: PropTypes.node,
  pageTitle: PropTypes.string
}
